import { csvParse } from 'omni-campaign-ui';
import { rfcColors } from '../campaign-audience-viz/campaign-audience-rfc-legend.js';

// Hardcoded role for comms data. Stored as CSV to make it easier to modify and more compact.
// In theory this should live in omni dictionary or similar as reference data.
// If we need to update this file, see the 'compress-rfc.py' script in this directory
import { csvData } from './channel-wheel-rfc-rules.js';

// Transform the data for easy lookup
const lookup = {};
csvParse(csvData.trim()).forEach(row => {
  const key = [row.channel, row.activity, row.ad_format]
    .filter(x => x)
    .join('-');
  lookup[key] = {
    activating: row.activating === '1',
    impacting: row.impacting === '1',
    building: row.building === '1',
    reinforcing: row.reinforcing === '1',
  };
});

export const rfcColor = (channel, activity, adFormat, role) => {
  if (!role) return undefined;
  // Look for most specific rule that exists and use that
  const match =
    lookup[`${channel}-${activity}-${adFormat}`] ??
    lookup[`${channel}-${activity}`] ??
    lookup[channel];
  if (!match || !match[role]) return undefined;
  return rfcColors[role];
};
